import { get } from './ajax.js';

export default class LSAppend {
  constructor() {
    // Public variables to store button parameters
    this.page = 1;
    this.perPage = null;
    this.nonce = null;
    this.action = null;
    this.streamType = null;
    this.gridType = null;
    this.totalPages = null;
    this.buttonElement = null;

    this.init();
  }

  init() {
    jQuery(document.body).on("click", ".ls-load-more", this.loadMore.bind(this));
  }

  loadMore(e) {
    e.preventDefault();

    // Store the button element
    this.buttonElement = e.currentTarget;

    // Get all data attributes from the button
    const button = jQuery(this.buttonElement);

    // Store all parameters in public variables
    this.page = parseInt(button.data('current-page') || 1) + 1;

    this.function = button.data('function');
    this.target = button.data('target');

    this.totalPages = parseInt(button.data('maxpage') || 1);

    if (!this.function) {
      console.log('Function not defined');
    }
    if (!this.target) {
      console.log('Target not defined');
    }

    // You can now use these variables for your AJAX request or other functionality
    this.performRequest();
  }

  performRequest() {
    // Create a data object with all button parameters
    const requestData = {
      page: this.page,
      function: this.function,
      target: this.target,
      total_pages: this.totalPages,
      _ajax_nonce: window.streamitAjax,
    };

    // Get all data attributes from the button to include any additional parameters
    const button = jQuery(this.buttonElement);
    const dataAttrs = button.data();

    // Add all data attributes to the request
    for (const [key, value] of Object.entries(dataAttrs)) {
      if (!requestData[key]) {
        requestData[key] = value;
      }
    }

    // Hide the button while loading
    button.hide();

    get('append_ajax_data', requestData)
      .then(res => {
        if (res.success) {
          // Determine the correct data structure (either res.data or res.data.data)
          const contentData = res.data.data ? res.data.data : res.data;

          // If target exists and content data is available
          if (this.target && contentData) {
            // Ensure we're finding the correct element by ID or class
            let targetElement;

            // Check if target starts with # (ID selector) or . (class selector)
            if (this.target.startsWith('#') || this.target.startsWith('.')) {
              targetElement = jQuery(this.target);
            } else {
              // If no prefix, assume it's an ID
              targetElement = jQuery('#' + this.target);
            }

            // Check if the element exists before appending
            if (targetElement.length > 0) {
              targetElement.append(contentData);

              // Update both the data attribute and the actual HTML attribute
              button.data('current-page', this.page);
              button.attr('data-current-page', this.page);


              // Show the button if there are more pages to load
              if (this.page < this.totalPages) {
                button.show();
              } else {
                button.hide();
              }
            } else {
              button.show(); // Show button again in case of error
            }
          } else {
            button.show(); // Show button again in case of error
          }
        } else {
          button.show(); // Show button again in case of error
        }
      })
      .catch(error => {
        console.error('AJAX request failed:', error);
        button.show(); // Show button again in case of error
      });
  }
}